/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAclImport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V14h-2V9h-5V4H6v16h9v2H4V2zm11 3.414V7h1.586L15 5.414zM21 16v3.586l1.293-1.293 1.414 1.414L20 23.414l-3.707-3.707 1.414-1.414L19 19.586V16h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAclImport as AclImport };
